
import React, { useState, useEffect, useRef } from "react";
import "./section1.css";

import v1 from "./images/slide1.mp4";
import v2 from "./images/slide2.mp4";
import v3 from "./images/slide3.mp4";
import v4 from "./images/slide4.mp4";
import v5 from "./images/slide5.mp4";
 import Contactform from './form-nav.js';
 import Callbtn from "./callbtn.js";
const videos = [
  {
    src: v1,
    title1: "Start Your Journey ",
   title2: <> in <span className="highlight">Cyber Security</span> </>,
   
  },
  {
    src: v2,
    title1: "Learn to Protect ",
   title2: <> the <span className="highlight">Digital World</span> </>,
  },
  {
    src: v3,
    title1: "Turn Your Passion",
    title2: <>into a <span className="highlight"> Career</span> </>,
   
  },
  {
    src: v4,
    title1: "Build Skills That ",
     title2: <> <span className="highlight-color"> Companies Need</span> </>,
   
  },
  {
    src: v5,
     title1: "Secure Your Future",
   title2: <>with the <span className="highlight">Right Skills</span> </>,
   
  }
];

const VideoSlider = () => {
  const [index, setIndex] = useState(0);
  const videoRefs = useRef([]);

  useEffect(() => {
    videoRefs.current.forEach((video, i) => {
      if (video) {
        if (i === index) {
          video.currentTime = 0;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    });
  }, [index]);

  const nextVideo = () => {
    setIndex((prev) => (prev + 1) % videos.length);
  };

  const prevVideo = () => {
    setIndex((prev) => (prev - 1 + videos.length) % videos.length);
  };

  return (
    <div className="background">
      <div className="slider">
        
        {videos.map((vid, i) => (
          <video
            key={i}
            ref={(el) => (videoRefs.current[i] = el)}
            className={`video 
              ${i === index ? "active" : ""} 
              ${i < index ? "left" : ""}
            `}
            muted
            playsInline
            preload="auto"
            onEnded={nextVideo}
          >
            <source src={vid.src} type="video/mp4" />
          </video>
        ))}

        {/* 🔥 TEXT OVERLAY */}
        <div className="content">
          <h1>{videos[index].title1}</h1>
          <h1>{videos[index].title2}</h1>
           <div className="call-btn">

          <Callbtn/>
          </div>
          <div>
           <div align="center"> <Contactform/></div>
          </div>
        </div>

        

      </div>
</div>
  );
};

export default VideoSlider;